/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Status_In_ProgressInputs */

const en_claim_status_in_progress = /** @type {(inputs: Claim_Status_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress on Zendesk`)
};

/**
* | output |
* | --- |
* | "In progress on Zendesk" |
*
* @param {Claim_Status_In_ProgressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_status_in_progress = /** @type {((inputs?: Claim_Status_In_ProgressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Status_In_ProgressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_status_in_progress(inputs)
});